import { render, staticRenderFns } from "./StandardSnackbar.vue?vue&type=template&id=ad6f4d38&scoped=true&lang=html&"
import script from "./StandardSnackbar.vue?vue&type=script&lang=js&"
export * from "./StandardSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6f4d38",
  null
  
)

export default component.exports